import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Table, TableColumn } from 'tea-component';
import ReportCard from '../../../components/ReportCard';
import { getRecordKeyOfMockable, formatBoolFalg } from '@gp/utils/common';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { buildProjectColumn } from '../../../utils/columns';
import { CARD_TITLE } from './utils';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportChangeVO } from '@gp/types/dpsReport/v2';

interface IReviewChangesProps extends IBaseProps {
  // 模块数据
  value: IDPSReportChangeVO[];
}

const ReviewChanges: React.FC<IReviewChangesProps> = (props) => {
  const { style, className, value: records } = props;

  const columns = useMemo<TableColumn<IDPSReportChangeVO>[]>(
    () => [
      buildProjectColumn(),
      CommonColumnBuilders.buildPureTextColumn({ key: 'field', header: 'Field of Change' }),
      CommonColumnBuilders.buildRichTextColumn({ key: 'new_value', header: 'New Value' }),
      CommonColumnBuilders.buildRichTextColumn({ key: 'original_value', header: 'Original Value' }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'approved',
        header: 'Approval',
        width: 110,
      }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'memo',
        header: 'Memo',
        width: 90,
        formatter: (cvm) => formatBoolFalg(cvm?.memo),
      }),
      CommonColumnBuilders.buildLineWrapperTextColumn({ key: 'next_step', header: 'Next Steps' }),
    ],
    [],
  );

  return (
    <ReportCard
      style={style}
      className={classnames('dbg-dps-report__changes-table-card', className)}
      title={CARD_TITLE}
    >
      <Table
        className="dbg-dps-report__boeder-table"
        columns={columns}
        records={records}
        recordKey={getRecordKeyOfMockable}
      />
    </ReportCard>
  );
};

export default ReviewChanges;
